import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import StripeCheckout from "react-stripe-checkout";

const stripePublishableKey =
  "pk_test_51M21TPKPPt2IOFXIEyxqgAZuMeoImvJZtHkL8GNjQ8s4R81JQHYFsa8AdrunWVDq8VCJ69Gorwz1N23Vza1gvJCY004saVEV1L";
const stripePromise = loadStripe(stripePublishableKey);

export const PaymentSelectionPage = () => {
  const [amount, setAmount] = useState("");

  const onAmountInputChange = (event) => {
    setAmount(event.target.value);
  };

  const handlePayment = async () => {
    const stripe = await stripePromise;
    console.log(stripe, "====================");
    if (!amount || amount <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    // const { error } = await stripe.redirectToCheckout({
    //   lineItems: [
    //     {
    //       price: "price_1QsCU4KPPt2IOFXIgfO1fAfA", // Replace with the ID of your price
    //       quantity: 1,
    //     },
    //   ],
    //   mode: "payment",
    //   successUrl: "https://www.google.com/success",
    //   cancelUrl: "https://www.yahoo.com/cancel",
    // });

    const sessionUrl = `https://donate.stripe.com/test_9AQ02Bdnhbk7epacMM?prefilled_price=${amount}`;
    window.location.href = sessionUrl;
  };

  const onToken = (token) => {
    fetch("/save-stripe-token", {
      method: "POST",
      body: JSON.stringify(token),
    }).then((response) => {
      response.json().then((data) => {
        alert(`We are in business, ${data.email}`);
      });
    });
  };

  return (
    <div className="container">
      <h1>Select payment amount</h1>
      <InputGroup className="mb-3">
        <InputGroup.Text>$</InputGroup.Text>
        <Form.Control
          aria-label="Amount (to the nearest euro)"
          type="number"
          onInput={onAmountInputChange}
        />
        <InputGroup.Text>.00</InputGroup.Text>
      </InputGroup>
      <Button variant="primary" onClick={handlePayment}>
        Donate {amount} €
      </Button>
      <StripeCheckout
        token={onToken}
        stripeKey={stripePublishableKey}
        currency="Euro"
        amount={2000}
      />
    </div>
  );
};
